import React, {useEffect} from "react";

class Component extends React.Component {
    iframe() {
        return {
            __html: this.props.iframe
        }
    }

    render() {
        return (
            <div>
                <div dangerouslySetInnerHTML={this.iframe()}/>
            </div>
        );
    }
}

const StrahovanieClient = () => {
    useEffect(() => {
        console.log('use effect')
        document.title = "Страхование | В разработке";
        const script = document.createElement("script");

        script.src = "https://partner.prosto.insure/widget/common.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);
    const iframe = `<iframe src="https://partner.prosto.insure/widget/sport?rel=u-QP5vr7INFziYETN&item=FUTBOL&bg=green"
                    scrolling="no" style="width:100%;min-height:670px;min-width:334px;border:none;border-radius:4px;" data-pi-widget="sport">
            </iframe>`
    return (
        <div>
            Страхование тут
            <Component iframe={iframe}/>
        </div>
    )
};

export default StrahovanieClient;
